import { CheckCircle, Create } from '@mui/icons-material'
import { Typography, useTheme } from '@mui/material'
import { Button, Tooltip } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"

interface IStatusProps {
    status: string
    grade: number
    onClick?: any
}
  
export const SubmissionStatus: FC<IStatusProps> = (({ status, grade, onClick=()=>{} }) => {
    const { t } = useTranslation()
    const theme = useTheme()
  
    return (
      <Tooltip title={`${t('common.view')}`} arrow placement='top'>
        <Button onClick={onClick}
  
        variant='outlined'
        disableElevation
        sx={{
          '&:hover': { background: theme.palette.primary.main, border: 'none', '& svg': { color: '#000' } },
          borderRadius: '50%',
          color: '#000',
          height: '2.5rem',
          padding: '0.5rem',
          minWidth: 'auto',
          display: 'flex',
          alignItems: 'center',
          border: 'none',
        }}
        
        >
          { status === 'published' || grade > 0
            ? <><Typography sx={{ fontSize: '11px' }}>{t('assignments.done')}</Typography> <CheckCircle sx={{ marginLeft: 1, color: theme.palette.success.main }} /></> 
            : <><Typography sx={{ fontSize: '11px' }}>{t('assignments.todo')}</Typography> <Create sx={{ marginLeft: 1, color: theme.palette.error.main }} /></> 
          }
        </Button>
      </Tooltip>
    )
  })
  